// extracted by mini-css-extract-plugin
module.exports = {"pageCounter":"PageCounter_pageCounter__1gPPF"};